// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"3ca7c1c2","453":"1b9726e4","777":"fccfcd18"}[chunkId] + ".chunk.js";
};